import React from 'react'
import { concatStyles } from 'utils'
import { Popover, PopoverContent, PopoverTrigger } from '../core/popover'
import { ColorOption } from './ColorOption'
import { Indicator } from './Indicator'
import { cn } from '../core/utils'

export interface IColorPickerProps {
  colors: string[]
  disabled?: boolean
  selectedColor?: string
  size?: number
  title?: string
  className?: string
  onSelectColor?: (color: string) => any
}

/**
 * Renders a color picker dialog using Popover.
 * @param props Any configuration for this component.
 */
export const Picker: React.FC<IColorPickerProps> = ({
  colors,
  disabled,
  onSelectColor,
  selectedColor,
  title,
  size,
  className,
}) => {
  const selectColor = (color: string): React.MouseEventHandler => () => {
    if (onSelectColor) {
      onSelectColor(color)
    }
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div>
          <Indicator
            size={size || 32}
            color={selectedColor}
            onClick={() => {}}
            disabled={disabled}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent
        className={cn('p-2 w-64 bg-white', className)}
        align="start"
        sideOffset={0}
      >
        {title ? <h3 className="text-base font-medium mb-2">{title}</h3> : null}
        <ul className="grid grid-cols-6 gap-4 m-0 p-0 bg-white">
          {colors.map((color) => (
            <li key={color} className="p-0 list-none">
              <ColorOption
                color={color}
                selected={selectedColor === color}
                onClick={selectColor(color)}
              />
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  )
}
